module.exports = __webpack_public_path__ + "static/media/ex-blog-post.5d02ac3d.jpg";